import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { DataTable } from "@client.components/DataTable/DataTable";
import { getUserColumns } from "./consts";
import { getUsersAsync, makeUsers } from "@client.pages/Settings/reducer";
import TopBar from "./TopBar";
import "./UsersDataTable.scss";

const UsersDataTable = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [filter, setFilter] = useState({});
  const users = useSelector(makeUsers);
  const gridRef = useRef(null);

  useEffect(() => {
    dispatch(getUsersAsync());
  }, [dispatch]);

  return (
    <div className="users-data-table">
      <TopBar
        getGridRef={() => gridRef}
        onRoleFilterChange={(v) => {
          setFilter(v ? { role: v } : {});
        }}
      />
      <DataTable
        ref={gridRef}
        columns={getUserColumns(t)}
        data={users.data.filter((u) => {
          for (const fieldName in filter) {
            if (filter[fieldName] !== u[fieldName]) {
              return false;
            }
          }
          return true;
        })}
        isLoading={users.load}
      />
    </div>
  );
};

export default UsersDataTable;
